import React from 'react';
import './styleCardProducto.css';
import { message } from 'antd';

const CardProductos = ({ productoFull, procesarSeleccionProducto, id, codigo_barras, nombre, image, precioVenta, stock, descuento, setBusqueda }) => {

  const handleAgregarClick = () => {
    // Si la función no llegó, evitamos que la app se rompa
    if (!procesarSeleccionProducto) {
      message.error("Error interno: Función de selección no conectada.");
      return;
    }

    procesarSeleccionProducto(productoFull);
    if (setBusqueda) setBusqueda('');
  };

  const precioFinal = descuento > 0
    ? precioVenta * (1 - descuento / 100)
    : precioVenta;

  return (
    <div
      onClick={handleAgregarClick}
      className="card-producto group cursor-pointer"
      style={{ display: 'flex', flexDirection: 'column', height: '100%', position: 'relative', background: '#fff', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.06)', border: '1px solid #f1f5f9' }}
    >
      {/* Badge de Descuento */}
      {descuento > 0 && (
        <div className="badge-oferta" style={{ position: 'absolute', top: '8px', left: '8px', background: '#facc15', color: '#854d0e', padding: '2px 8px', borderRadius: '8px', fontSize: '11px', fontWeight: 'bold', zIndex: 10 }}>
          -{Math.round(descuento)}%
        </div>
      )}

      {/* Imagen */}
      <div className="w-full aspect-square overflow-hidden bg-white relative">
        <img
          src={image}
          alt={nombre}
          className="absolute inset-0 w-full h-full object-contain p-1 transition-transform duration-150 group-hover:scale-105"
        />
      </div>

      {/* Información */}
      <div className="divInfoCard" style={{ padding: '10px', display: 'flex', flexDirection: 'column', flex: 1, borderTop: '1px solid #f8fafc' }}>

        {/* Título de 2 líneas máximo */}
        <p className="nombre-producto" style={{ fontSize: '13px', fontWeight: '600', color: '#1e293b', lineHeight: '1.2', marginBottom: '8px', overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' }}>
          {nombre}
        </p>

        {/* Sección Precio y Stock Apilada (Column) */}
        <div style={{ marginTop: 'auto', display: 'flex', flexDirection: 'column', gap: '4px' }}>

          {/* Fila del precio */}
          <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px', flexWrap: 'wrap' }}>
            {descuento > 0 && (
              <span style={{ textDecoration: 'line-through', color: '#94a3b8', fontSize: '11px' }}>
                ${Number(precioVenta).toLocaleString("es-CO")}
              </span>
            )}
            <span style={{ fontWeight: '800', color: descuento > 0 ? '#e11d48' : '#0f172a', fontSize: '15px' }}>
              ${Math.round(precioFinal).toLocaleString("es-CO")}
            </span>
          </div>

          {/* Fila del Stock o Etiqueta de Variantes */}
          {productoFull?.has_variants ? (
            <div style={{ background: '#e0f2fe', color: '#0284c7', padding: '2px 8px', borderRadius: '6px', fontSize: '11px', fontWeight: '700', alignSelf: 'flex-start', border: '1px solid #bae6fd' }}>
              Múltiples Opciones
            </div>
          ) : (
            <p style={{ fontSize: '11px', color: stock <= 2 ? '#ef4444' : '#64748b', margin: 0 }}>
              Stock: <span style={{ fontWeight: '800' }}>{stock}</span>
            </p>
          )}

        </div>
      </div>
    </div>
  )
}

export default CardProductos;